// extracted by mini-css-extract-plugin
export default {"container":"Er-z","brandName":"Fr-z","productName":"Gr-z","productNamePdpEnhancements":"Hr-z","breakLongProductName":"Ir-z"};